/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown> }} Audio_Recorder_Microphone_LabelInputs */



/**
* | output |
* | --- |
* | "Microphone {index}" |
*
* @param {Audio_Recorder_Microphone_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_microphone_label = /** @type {((inputs: Audio_Recorder_Microphone_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_Microphone_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Microphone ${i?.index}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Mikrofon ${i?.index}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Microfono ${i?.index}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Микрофон ${i?.index}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Micrófono ${i?.index}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`麦克风 ${i?.index}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`マイク ${i?.index}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`माइक्रोफ़ोन ${i?.index}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Microfone ${i?.index}`)
	return /** @type {LocalizedString} */ (`Microphone ${i?.index}`)
});